import styled from "styled-components";

export const FieldWithButtonContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 15px;
  width: 100%;

  .MuiTextField-root {
    width: 50%;
  }
`;
